import { Navigate, useLocation } from "react-router-dom";
import { continueCookieName, cookieDomain } from "@/environment";

import Cookies from "js-cookie";
import React, { useEffect, useRef } from "react";
import Unauthorized from "@/dashboard/features/auth/Unauthorized/Unauthorized";
import { isLoggedIn } from "@/utils/api";
import { useSelector, useDispatch } from "react-redux";
import { clearForbidden } from "@/slices/auth";

export const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isForbidden = useSelector((state) => state.auth.isForbidden);
  const previousPathname = useRef(location.pathname);

  // Clear forbidden state when navigating to a different route
  useEffect(() => {
    if (isForbidden && location.pathname !== previousPathname.current) {
      dispatch(clearForbidden());
    }
    previousPathname.current = location.pathname;
  }, [location.pathname, dispatch, isForbidden]);

  if (isForbidden) {
    return <Unauthorized />;
  }

  if (isLoggedIn()) {
    return children;
  } else {
    // window.sessionStorage.setItem("continue", props.location.pathname);
    Cookies.set(continueCookieName, location.pathname, {
      domain: cookieDomain,
    });

    return (
      <Navigate
        to={{
          pathname: "/employers/login",
        }}
        state={{ from: location }}
      />
    );
  }
};
